<template>
  <div class="columns columnsLessons" id="columns" style="width:unset !important">
    <v-card flat class="column is-one-quarter border-right" style="overflow: auto; width:25vw">
      <v-list>
        <v-list-item-group
        v-model="selectedLessonIndex"
        color="primary"
      >

      <v-list-item
        @click="itemSelected(item)"
        v-for="(item, index) in lessons"
        :key="index"
      >
        <v-list-item-content class="list-item">
          <v-list-item-title class="text-wrap">
            {{item.lessonTitle}}
          </v-list-item-title>
          <v-list-item-subtitle v-if="containsLetters(item.lessonSubtitle)">
            {{ item.lessonSubtitle }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      </v-list-item-group>
      </v-list>
    </v-card>
    <div class="videoBackground">
      <video class="videoFrame" controls :key="selectedLesson.fileName">
        <source :src="selectedLesson.fileName" type="video/webm">
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
  },
  data() {
    return {
        lessons: [],
        selectedLesson: {},
        selectedLessonIndex: 0,
        lessonSelected: true
    };
  },
  async mounted(){
    let htmlContentFileServer = await this.fetchDirectoryListing();
    const files = this.extractVideoFiles(htmlContentFileServer);
    files.forEach(elem => {
      let lessonNum = this.extractNumber(elem).toString();
      const parts = elem.split('-');
      // Extract Lesson Title and Lesson Subtitle
      const lessonTitle = lessonNum.split(".")[0]+" "+parts[3].replace('.webm', '').replace(/([A-Z])/g, ' $1').trim();
      const lessonSubtitle = lessonNum + " " + parts.slice(5).join(' ').replace('.webm', '').replace('_', '').replace(/([A-Z])/g, ' $1').trim();
      this.lessons.push({
        order: lessonNum,
        fileName: "https://app.motiverse.de/lessons/"+elem,
        lessonTitle: lessonTitle,
        lessonSubtitle: lessonSubtitle
      })
    })
    this.lessons.sort((a, b) => a.order.localeCompare(b.order, undefined, { numeric: true }));
    this.selectedLesson = this.lessons[0];
    this.selectedLessonIndex = 0;
  },
  methods: {
    async fetchDirectoryListing() {
        const response = await fetch("https://app.motiverse.de/lessons/");
        if (response.ok) {
            return await response.text();
        } else {
            throw new Error('Failed to fetch directory listing');
        }
    },
    extractVideoFiles(htmlContent) {
        const regex = /<a href="([^"]+\.webm)">/g;
        const matches = [];
        let match;
        while ((match = regex.exec(htmlContent)) !== null) {
            matches.push(match[1]);
        }
        return matches;
    },
    itemSelected(item, idx){
        this.selectedLessonIndex = idx;
        this.lessonSelected = false;
        this.selectedLesson = item;
        this.lessonSelected = true;
    },
     extractNumber(filename) {
        // Use a regular expression to find all numbers in the filename
        const numbers = filename.match(/\d+/g);

        if (!numbers) {
          // If no numbers are found, return null or any other appropriate value
          return null;
        } else {
          // Join the numbers with a dot and parse as float
          let result = parseFloat(numbers.join('.'));

          // Check if the filename contains "demo" and adjust the result accordingly
          if (filename.toLowerCase().includes("demo")) {
            result = parseFloat(result.toString() + "." +numbers.length);
          }

          return result;
        }
      },
      containsLetters(text) {
        // Check if the text contains letters
        return /[a-zA-Z]/.test(text);
      }
  }
};
</script>

<style>
.videoBackground{
  background-color: #F5F5F5;
  height:100%;
  padding: 10px;
  width:100%
}
.videoFrame{
  width: 100%
}
.columnsLessons{
  height:calc(100% - 4vh - 48px - 72px) !important;
}
</style>